import { CompoundEntityRef } from '@backstage/catalog-model'
import { createApiRef } from '@backstage/core-plugin-api'
import { AwsLambda } from '@internal/backstage-plugin-veho-backstage-common'

export interface AwsLambdaApi {
  getLambdasByEntity(entityRef: CompoundEntityRef): Promise<AwsLambda[]>
}

export const awsLambdaApiRef = createApiRef<AwsLambdaApi>({
  id: 'plugin.aws-lambda.service',
})
